export const environment = {
  production: false,
  URL_API: "https://us-central1-provenance-310914.cloudfunctions.net/api"
  //URL_API: "http://localhost:5001/provenance-310914/us-central1/api"
};